import { Footer } from "../../../Footer/Footer"
import { HerosectionsAll } from "../../../HeroSectionAll/HerosectionsAll"
import { Header } from "../../../IndexPage/Header/Header"


export const LossofHireClaims = () => {
    return (
        <>
 <div className="container-fluid">
            <div className="row " style={{ background: '#fff' }} onLoad={() => window.scrollTo(0, 0)}>
                <div className="col-12">
                    <Header actives="LossofHireClaims" />
                    <HerosectionsAll ScreenName="Loss of Hire Claims" ScreenSearch="hull" />

                    <div className="row col-lg-9 mx-auto p-2 p-lg-5 my-5">
                        <div className="col-12 p-lg-5 faint" style={{ textAlign: 'justify', }}>
                            <h5 className="fw-bold gray_color py-3">Loss of Hire Claims</h5>

                            <p>Loss of Hire policy indemnify the shipowner when following a casualty the vessel is put off-Hire. It is loss of hire income of the shipowner which he (mostly) insured against the ABS Wordings or Nordic plans or US Lazard Form. This loss of income of the shipowner is linked with the physical loss or damage to the vessel covered under Hull & Machinery policy. Policies will be subject to deductibles which are mentioned as number of days. </p>
                            <p>We assist our clients in interpreting the policy coverage, advising regarding the correct period to be consider for the Loss of Hire claim and assist in presentation of the claim. </p>

                        </div>
                    </div>

                    <Footer />
                </div>
            </div>
</div>

        </>
    )
}
